import React from "react";
import { condition, accountTypeMap, ECOA } from "_helpers/experian";
import { flatMoney, FormatDate } from "_assets/js/helpers";
import "./Installments.scss";

const termCalculator = (tradeline) => {
  if (!tradeline?.terms) return "-";
  const term = parseInt(tradeline?.terms) || 0;
  return term + " months";
};

function Installments(props) {
  const { installment } = props;
  return installment.map((m, i) => {
    const e = m?.enhancedPaymentData;
    let openOrClosed = m?.openOrClosed || "O";
    if (
      openOrClosed === "O" &&
      (m?.balanceAmount || m?.amount1) === "00000000"
    ) {
      openOrClosed = "P";
    }
    return (
      <div key={`crmortages-${i}`} className="wzrd-box installment">
        <div className="wzrd-body">
          <div className="trade-header">
            <h3>{m?.subscriberName}</h3>
            <p>
              {m?.kob} {m?.specialComment ? `/ ${m?.specialComment}` : ""}
            </p>
            <div>
              <b>Account #:</b> {m?.accountNumber || "-"}
            </div>
          </div>
          <div className={`trade-condition trade-${openOrClosed}`}>
            {condition[openOrClosed]}
          </div>
          <div className="trade-box">
            <div className="trade-items">
              <div className="trade-item">
                <h5>Payment Status</h5>
                <p>{m?.status || "-"}</p>
              </div>
              <div className="trade-item">
                <h5>Responsibility</h5>
                <p>{ECOA[m?.ecoa] || m?.ecoa || "-"}</p>
              </div>
              <div className="trade-item">
                <h5>Account Term</h5>
                <p>{termCalculator(m) || "-"}</p>
              </div>
            </div>
            <div className="trade-items">
              <div className="trade-item">
                <h5>Account Type</h5>
                <p>{accountTypeMap[m?.accountType] || m?.accountType || "-"}</p>
              </div>
            </div>
          </div>
          <div className="trade-list">
            <div>
              <h5>Open Date</h5>
              <p>{FormatDate(m?.openDate)}</p>
            </div>
            <div>
              <h5>Status Date</h5>
              <p>{FormatDate(m?.statusDate)}</p>
            </div>
            <div>
              <h5>Last Paid Date</h5>
              <p>{FormatDate(m?.lastPaymentDate)}</p>
            </div>
            <div>
              <h5>Balance Date</h5>
              <p>{FormatDate(m?.balanceDate)}</p>
            </div>
            <div>
              <h5>Current Balance</h5>
              <p>{flatMoney(parseInt(m?.balanceAmount || "0"))}</p>
            </div>
            <div>
              <h5>Monthly Payment</h5>
              <p>{flatMoney(parseInt(m?.monthlyPaymentAmount || "0"))}</p>
            </div>
            <div>
              <h5>Last Payment</h5>
              <p>
                {e?.actualPaymentAmount
                  ? flatMoney(parseInt(e?.actualPaymentAmount))
                  : "-"}
              </p>
            </div>
            <div>
              <h5>Original Amount</h5>
              <p>
                {flatMoney(
                  parseInt(e?.originalLoanAmount || m?.amount1 || "0")
                )}
              </p>
            </div>
            <div>
              <h5>Past Due</h5>
              <p>{"---"}</p>
            </div>
          </div>
        </div>
      </div>
    );
  });
}

export default Installments;
